import { Geocoder } from './geocoder';
import GeoJSON from 'ol/format/GeoJSON.js';

const URL = "https://nominatim.openstreetmap.org/search";
const ROWS = 10;

class NominatimGeocoder extends Geocoder {
	
	constructor() {
		super();	
	}
	
	setMap(map) {
		super.setMap(map);
		
		this.geojson = new GeoJSON({
			dataProjection: this.wgs84,
			featureProjection: map.getView().getProjection() 
		});
	}
	
	async search(query) {
		const extent = this.getExtent();
		const viewbox = extent.join(",");		

		const url = `${URL}?q=${query}&limit=${ROWS}&viewbox=${viewbox}&format=geojson&polygon_geojson=1`
		
		const result = await fetch(url);
		const text = await result.text();
		
		const values = this.geojson.readFeatures(text);
		return values.map(value => this.createRecord(value));		
	}
	
	createRecord(feature) {
		return this.create(feature.get('display_name'), feature.getGeometry());
	}
}

export { NominatimGeocoder }